import {
  Box, DashboardModuleListItem, Tag,
} from '@domain-group/suit-theme'

import type { TaskListItemModel } from '@domain-group/realhub-backend-api-types'

import useTaskListItem from '@hooks/useTaskListItem'

interface TaskListItemProps {
  taskListItem: TaskListItemModel,
}

const TaskListItem = (props: TaskListItemProps) => {
  const { taskListItem } = props

  const taskListItemPayload = useTaskListItem(taskListItem)
  const {
    callbacks: {
      toggleCompletion,
    },
    taskListItem: {
      assigned_points, completed, description, title,
    },
  } = taskListItemPayload

  return (
    <DashboardModuleListItem
      isChecked={completed}
      onClick={() => toggleCompletion()}
      secondaryText={description}
      showCheckbox
      title={title}
    >
      <Box marginLeft="auto" width="auto">
        {!!assigned_points && (
          <Tag
            boxProps={{
              color: 'bodyFontColor',
              display: 'inline-flex',
              fontSize: 'xxsmall',
              fontStyle: 'normal',
              paddingX: 'medium',
              variant: 'whiteGrey',
            }}
            // @ts-expect-error TS2322
            width="auto"
          >
            {assigned_points} Points
          </Tag>
        )}
      </Box>
    </DashboardModuleListItem>
  )
}

export default TaskListItem
